export const SET_BUSINESS_FILTERS = 'SET_BUSINESS_FILTERS';

export const SET_BUSINESS_GRID_SORT_CRITERIA = 'SET_BUSINESS_GRID_SORT_CRITERIA';

export const RESET_BUSINESS_FILTERS = 'RESET_BUSINESS_FILTERS';
